module.exports = __webpack_public_path__ + "img/主页图片2-tuya.2d19c918.png";